import React from "react";

import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import { AvatarGroup, Button, Stack } from "@mui/material";
import { VisibilityLock } from "assets/material-custom-icons";
import { Avatar, TooltipDiv } from "components";
import { useRoleGuardHook } from "hooks";
import { useDealCSSelector, usePickUserPermissions, useUserRoleSelector, useViewActions } from "store";
import { ICapitalSeeker, IFolder, IFolderMetaShare, IMetaDetails, UserPermissionType } from "store/types";

import { RoleName } from "../../../constants";

interface Props {
  currentFolder: IFolder;
  shared_with: IFolderMetaShare[];
  details: IMetaDetails[];
  is_private: boolean;
  title: string;
}

export const Share: React.FC<Props> = ({ currentFolder, shared_with, details, is_private, title }) => {
  const role = useUserRoleSelector();
  const { setShareDialog } = useViewActions();
  const capitalSeekers = useDealCSSelector();
  const capitalSeeker: ICapitalSeeker | undefined = capitalSeekers?.[0];
  const handleShare = useRoleGuardHook(() => {
    if (!currentFolder) return;
    setShareDialog({
      elements: [currentFolder.id],
      type: "section_id",
      shareName: currentFolder.title,
      dealId: currentFolder.deal_id,
      dealCapitalSeekerEmail: capitalSeeker?.email,
      itemToShare: currentFolder.is_private ? null : currentFolder.id
    });
  }, [RoleName.Admin, RoleName.Analyst]);
  const myDeals = usePickUserPermissions("deals");
  const noAccessPermission = myDeals && myDeals === UserPermissionType.NO_ACCESS;
  const isViewerPermission = myDeals && myDeals === UserPermissionType.VIEWER;

  const isMenuAvailable = role?.name === RoleName.Admin || role?.name === RoleName.Analyst;

  return (
    isMenuAvailable && (
      <Stack direction="row" alignItems="center">
        <AvatarGroup
          sx={{
            "& .MuiAvatar-root": { width: 20, height: 20, fontSize: 12 },
            marginRight: "10px"
          }}
          max={6}
        >
          {shared_with?.map((share: IFolderMetaShare, index: number) => (
            <TooltipDiv key={share.id + index} place="bottom" tooltipMessage={share.full_name}>
              <Avatar src={share.profile_photo_url} size={24} />
            </TooltipDiv>
          ))}
        </AvatarGroup>
        <Stack flexDirection="row" alignItems="center" justifyContent="center" gap="10px">
          {!!details?.length && !isViewerPermission && !noAccessPermission && (
            <Button
              variant="outlined"
              size="sm"
              onClick={() => title && handleShare && handleShare()}
              startIcon={<PersonAddOutlinedIcon sx={{ width: "20px", height: "20px" }} />}
            >
              Share
            </Button>
          )}
          {is_private && <VisibilityLock sx={{ fill: "#BAC7CE" }} />}
        </Stack>
      </Stack>
    )
  );
};
